import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";
import SectionLeft from "./SectionLeft";
import { SectionRight } from "./SectionRight";
import { FullscreenModal } from "@learningblocks/storybook-components/lib/FullscreenModal";
import { MICROPIPETTE_TYPE } from "@learningblocks/exp-constants/lib/Utilities";
import { VOLUME_CHART, VOLUME_UPDATE_INTERVAL } from "../MicroPipette.constants";

import "./style.scss";

const { P2, P20, P200, P1000 } = MICROPIPETTE_TYPE;

const round = (number, decimalPlaces) => {
    let result = number;
    if (decimalPlaces > 0) {
        const factorOfTen = Math.pow(10, decimalPlaces);
        result = Math.round(number * factorOfTen) / factorOfTen;
    }
    return result;
};
/**
 * VolumeModal:
 *  - Modal Window to set the MicroPipette Volume
 */
export function VolumeModal(props) {
    const [state, setState] = React.useState({
        value: props.volume,
        voluemUpdateInterval: VOLUME_UPDATE_INTERVAL,
        disabledSaveButton: false,
        leftSectionVolume: props.volume,
    });

    React.useEffect(() => {
        if (state.value !== props.volume) {
            setState({ value: props.volume, voluemUpdateInterval: VOLUME_UPDATE_INTERVAL });
        }
    }, [props.volume]);

    React.useEffect(() => {
        if (state.value !== props.volume) {
            setPipetteVolume();
        }
    }, [state.value]);

    const setDefaultVolume = () => {
        props.setVolume({ volume: VOLUME_CHART[props.type].min });
        setState({ value: VOLUME_CHART[props.type].min, voluemUpdateInterval: VOLUME_UPDATE_INTERVAL });
    };

    const setPipetteVolume = () => {
        props.setVolume({
            volume: state.value,
        });
    };

    const incrementVolume = () => {
        setState((state) => {
            let value = state.value + VOLUME_CHART[props.type].rate;
            value = setVolumeToLimits(value, props.type);
            return { ...state, value };
        });
    };

    const decrementVolume = () =>
        setState((state) => {
            let value = state.value - VOLUME_CHART[props.type].rate;
            value = setVolumeToLimits(value, props.type);
            return { ...state, value };
        });

    const setLeftSectionVolume = (volume) => {
        setState((state) => ({
            ...state,
            leftSectionVolume: volume,
            value: volume,
        }));
    };

    const disableSaveButton = (enabled) => {
        setState((state) => ({
            ...state,
            disabledSaveButton: enabled,
        }));
    };

    const onModalClose = () => {
        const volume = state.value;
        const rate = VOLUME_CHART[props.type].rate;
        const roundedVolume = Math.round(volume / rate) * rate;
        setState((state) => ({
            ...state,
            leftSectionVolume: roundedVolume,
            value: roundedVolume,
        }));
        props.onClose();
    };

    return (
        <FullscreenModal className={cname.vmodal} closeButton={true} close={onModalClose} isOpen={props.modalOpen} notebookExpanded={props.notebookExpanded} lang={props.lang}>
            <div className={cname.sections}>
                <SectionLeft
                    hasTip={props.hasTip}
                    volume={state.value}
                    setVolume={setLeftSectionVolume}
                    disableSaveButton={disableSaveButton}
                    type={props.type}
                    minVolume={VOLUME_CHART[props.type].min}
                    maxVolume={VOLUME_CHART[props.type].max}
                    updateRate={VOLUME_CHART[props.type].rate}
                    setDefaultVolume={setDefaultVolume}
                />
                <SectionRight type={props.type} volume={state.value} incrementVolume={incrementVolume} decrementVolume={decrementVolume} />
            </div>
        </FullscreenModal>
    );
}

VolumeModal.propTypes = {
    /**
     * Type of Micropipette [ P2, P20, P200, P1000]
     */
    type: PropTypes.oneOf([P2, P20, P200, P1000]),
    /**
     * Boolean for If pipette has tip attached
     */
    hasTip: PropTypes.bool,
    /**
     * Function to set selected volume to MicroPipette
     */
    setVolume: PropTypes.func,
    /**
     * Current selected volume
     */
    volume: PropTypes.number,
    /**
     * Callback to close the modal
     */
    onClose: PropTypes.func,
};

VolumeModal.defaultProps = {};

function setVolumeToLimits(value, type) {
    value = round(value, VOLUME_CHART[type].dp);
    if (value <= VOLUME_CHART[type].min) value = VOLUME_CHART[type].min;
    if (value >= VOLUME_CHART[type].max) value = VOLUME_CHART[type].max;
    return value;
}
